import { NeedDto, UserDto } from '@act/shared/data-transfer-objects';
import { CollapsibleCard } from '../../../../containers/Cards/Collapsible/CollapsibleCard';
import { NeedDateLine } from '../dateLines';
import { NeedGoalSummary } from '../summaries/NeedGoalSummary';
import { GoalCardActionItems } from '../../shared-types';
import { Dictionary } from '@act/shared/types';
import { IconAvatar } from '../../../../display/IconAvatar/IconAvatar';

interface NeedGoalCardProps {
  need: NeedDto;
  member: UserDto;
  userMap: Dictionary<UserDto>;
  actions?: GoalCardActionItems[];
  defaultClosed?: boolean;
  onToggleOpen?: () => void;
}

export const NeedGoalCard = ({
  need,
  member,
  userMap,
  actions,
  defaultClosed,
  onToggleOpen,
}: NeedGoalCardProps) => {
  return (
    <CollapsibleCard
      avatar={<IconAvatar avatarType="need" />}
      title={need.issueLabel}
      titleTypographyVariant="titleMedium"
      endContent={<NeedDateLine need={need} member={member} />}
      defaultClosed={defaultClosed}
      isCompact
      hideExpander
      shouldShowPointer
      onToggleOpen={onToggleOpen}
    >
      <NeedGoalSummary
        need={need}
        member={member}
        actions={actions}
        userMap={userMap}
      />
    </CollapsibleCard>
  );
};
